// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__0ZaHQ","show":"Tooltip_show__YVQ5+"};